import { useEffect, useState } from "react";
import ReasonCodeTable from "./table";
import { getReasonCodeDetails } from "~/services/supervisor.services";
import LoadingIcon from "~/components/form/LoadingIcon";

const ReasonCodeComponent = () => {
  const [ReasonCodeData, setReasonCodeData] = useState<any>(null);

  const fetchData = async () => {
    const { data, status } = await getReasonCodeDetails();
    console.log(data,status);
    if (status) {
        setReasonCodeData((data as any).data);     
    }
  };
  console.log(ReasonCodeData)
  useEffect(() => { 
    void fetchData();
  },[]);

  const handleDataUpdate = (updatedData: any[]) => {
    setReasonCodeData(updatedData);
  };
console.log(ReasonCodeData)
  return (
    <>
          <div className="mb-4">
        <div className="flex justify-right items-center mb-3 ml-7">
          <h4 className="text-2xl font-semibold text-orange-500">
           Reason Code
          </h4>
        </div>
      </div>
      {ReasonCodeData != null ? (
        <>
          <div className="bg-neutral-100 rounded-lg">
            <div className="p-2">{<ReasonCodeTable data={ReasonCodeData} onDataUpdate={handleDataUpdate} />}</div>
          </div>
        </>
      ): <LoadingIcon />}
    </>
  );
};
export default ReasonCodeComponent;

